export class authenticateRequest {
    userName: string;
    password: string;
    timeTicket: string;
}

export class DTOParameterModel {
    parameterId: string;
    parameterName: string;
    value: string;
    comment: string;
    isNotInUse: boolean;
    isDeleted: boolean;
}